export default {
      id: "message-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "sprite.svg#message",
      toString: function () {
        return this.url;
      }
    }